import { CLEAR_FORM, USER_FORM } from "../../utils/const"

const initialState: UserCreate = {
    email: '',
    password: '',
    name: '',
    rol: '',
}

export const userFormCreate = (state = initialState, action: any) => {

    switch (action.type) {

        case USER_FORM:

            var { key, value } = action.payload

            return {
                ...state,
                [key]: value
            }
        case CLEAR_FORM:
            return initialState
        default:
            return state

    }
}